<div class="flex flex-row gap-4 mt-2">
    <div
        class="basis-1/2">
        <nx-headline-box  
            [label]="'Rechnungsempfang'">
        </nx-headline-box>
        <nx-default-box
            class="bg-white border-b border-gray"
            [label]="'Abweichende E-Mail-Adresse'"
            [menuItems]="invoiceEmailMenuItems">
            {{tenant?.invoiceEmail ?  tenant?.invoiceEmail: '-'}}
        </nx-default-box>
        <nx-default-box
            class="bg-white border-b border-gray"
            [label]="'Abweichende Rechnungsadresse'"
            [menuItems]="invoiceAddressMenuItems">
            {{tenant?.invoiceAddress ?  buildInvoiceAddressRepresentation(tenant?.invoiceAddress): '-'}}
        </nx-default-box>
    </div>
    <div
        class="basis-1/2">
    </div>
</div>